import { Flashbar as CSDFlashbar } from "@cloudscape-design/components-themed";
import { useAppSelector } from "../../app/hook";

const Notifications = () => {
  const { notifications } = useAppSelector((state) => state.notifications);

  return <CSDFlashbar items={notifications} />;
};

export default Notifications;
